import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { clearPlayerLockout } from '../../services'

interface UseMutationClearPlayerLockoutProps {
	phone: string
}

export default function useMutationClearPlayerLockout(
	props?: UseBaseMutationOptions<void, UseMutationClearPlayerLockoutProps>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.ClearPlayerLockout],
		mutationFn: ({ phone }) => clearPlayerLockout(phone),
		...props,
	})
}
